module.exports = __webpack_public_path__ + "img/2025-08-16b_8.1ae2907c.jpg";